<template>
  <div class="text-sm h-full flex flex-col overflow-hidden">
    <header
      style="height: 60px"
      class="flex-shrink-0 grid w-full grid-cols-12 text-sm border-b"
    >
      <div
        class="col-span-6 md:col-span-4 lg:col-span-3 xl:col-span-2 pl-4 pt-2.5 border-0 border-r border-gray-200"
        style="background-color: #fafafa"
      >
        <TheLogo />
      </div>

      <div
        class="flex items-center h-full col-span-6 md:col-span-8 lg:col-span-9 xl:col-span-10"
      >
        <el-tooltip
          v-if="$route.name !== 'files-list'"
          :content="'Файлы'"
          placement="left"
          :show-after="300"
        >
          <router-link to="/">
            <HomeIcon
              class="text-gray-600 cursor-pointer hover:text-blue-500"
              style="
                fill: #f1f1f1;
                height: 18px;
                width: 18px;
                margin-left: 28px;
                margin-top: -1.5px;
              "
            />
          </router-link>
        </el-tooltip>
        <nav
          class="ml-6"
          :class="user.scopes.includes('annotator') ? '' : 'mr-7'"
        >
          <ul class="flex items-center text-sm">
            <li v-for="(l, index) in navLinks" :key="index">
              <template v-if="l.link.name === 'dictionary'">
                <a
                  :href="$router.resolve(l.link).href"
                  target="_blank"
                  rel="noopener noreferrer"
                  class="flex items-center cursor-pointer text-blue-600 underline-btn"
                >
                  <span>Поиск по словарю</span>
                  <arrow-right-up
                    style="
                      height: 18px;
                      width: 18px;
                      margin-top: 2px;
                      margin-left: 3px;
                    "
                  ></arrow-right-up>
                </a>
              </template>
              <template v-else>
                <router-link
                  style="font-size: 14px"
                  class="inline-block text-gray-500 hover:text-blue-500 bg-white px-1.5 pb-0.5 rounded"
                  active-class="text-blue-500 bg-blue-100"
                  :to="l.link"
                >
                  {{ l.title }}
                </router-link>
              </template>
            </li>
          </ul>
        </nav>
        <a
          :href="shortLink"
          target="_blank"
          class="flex items-center cursor-pointer text-blue-600 underline-btn"
        >
          <span>Правила разметки</span>
          <arrow-right-up
            style="height: 18px; width: 18px; margin-top: 2px; margin-left: 3px"
          ></arrow-right-up>
        </a>
        <a
          v-if="isKazTelecom"
          :href="wordPatterns"
          target="_blank"
          class="flex items-center cursor-pointer text-blue-600 underline-btn ml-6"
        >
          <span>Примеры слов</span>
          <arrow-right-up
            style="height: 18px; width: 18px; margin-top: 2px; margin-left: 3px"
          ></arrow-right-up>
        </a>
        <a
          v-if="isKTZ"
          :href="stationsList"
          target="_blank"
          class="flex items-center cursor-pointer text-blue-600 underline-btn ml-6"
        >
          <span>Список станций</span>
          <arrow-right-up
            style="height: 18px; width: 18px; margin-top: 2px; margin-left: 3px"
          ></arrow-right-up>
        </a>
        <div class="ml-auto mr-4">
          <SidebarUserCard />
        </div>
      </div>
    </header>
    <router-view class="flex-1 min-h-0 overflow-hidden" />
  </div>
</template>

<script>
import TheLogo from "@/components/header/TheLogo";
import ArrowRightUp from "@/icons/ArrowRightUp.vue";
import HomeIcon from "@/icons/HomeIcon.vue";
import SidebarUserCard from "@/components/SidebarUserCard.vue";

export default {
  name: "default",
  components: {
    SidebarUserCard,
    HomeIcon,
    ArrowRightUp,
    TheLogo,
  },

  computed: {
    shortLink() {
      if (this.domain === "https://kt.tr.q19.kz") {
        return "https://u.to/B2ZYIg";
      }
      return "https://u.to/SGsFIQ";
    },
    wordPatterns() {
      return "https://u.to/UqViIg";
    },
    stationsList() {
      return "https://u.to/GVBpIg";
    },
    isKazTelecom() {
      return window.location.hostname === "kt.tr.q19.kz";
    },
    isKTZ() {
      return window.location.hostname === "ktz.tr.q19.kz";
    },
    domain() {
      return window.domain;
    },
    user() {
      return this.$store.state.user.user;
    },
    navLinks() {
      if (!this.user) return [];

      const { scopes } = this.user;
      const links = [];

      if (scopes.includes("admin")) {
        links.push(
          { title: "Файлы", link: { name: "files" } },
          { title: "Управление", link: { name: "manage" } }
        );
      }

      if (scopes.includes("verifier") || scopes.includes("admin")) {
        links.push({ title: "Поиск по словарю", link: { name: "dictionary" } });
      }

      return links;
    },
  },
};
</script>

<style lang="scss">
nav ul li {
  margin-right: 30px;
  &:last-child {
    margin-right: 0;
  }
  a.router-link-active {
    color: #446bea;
    font-weight: normal;
  }
}
.underline-btn {
  @apply cursor-pointer flex items-center relative;
  text-decoration: none;

  &:before,
  &:after {
    content: "";
    display: block;
    position: absolute;
    height: 1px;
    width: 0;
  }

  &:before {
    transition: width 0s ease, background 0.4s ease;
    left: 0;
    right: 0;
    bottom: 4px;
  }

  &:after {
    right: 2.2%;
    bottom: 4px;
    @apply bg-blue-600;
    transition: width 0.4s ease;
  }

  &:hover {
    &:before {
      width: 97.8%;
      @apply bg-blue-600;
      transition: width 0.4s ease;
    }

    &:after {
      width: 97.8%;
      background: 0 0;
      transition: all 0s ease;
    }
  }
}
</style>
